import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-sm border border-[#E5E7EB] dark:border-[#374151] p-6 mb-6" }
const _hoisted_2 = { class: "flex flex-col lg:flex-row gap-4 items-center justify-between" }
const _hoisted_3 = { class: "flex-1 max-w-sm w-full" }
const _hoisted_4 = { class: "relative group" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = { class: "absolute top-full mt-1 right-0 bg-white dark:bg-[#1e293b] rounded-lg shadow-lg border border-[#E5E7EB] dark:border-[#334155] min-w-[180px] z-10 overflow-hidden" }
const _hoisted_9 = { class: "p-1" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = { class: "absolute top-full mt-1 right-0 bg-white dark:bg-[#1e293b] rounded-lg shadow-lg border border-[#E5E7EB] dark:border-[#334155] w-64 z-10 overflow-hidden" }
const _hoisted_13 = { class: "p-4" }
const _hoisted_14 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_15 = { class: "block text-xs font-medium text-[#6B7280] dark:text-[#94A3B8] mb-1" }
const _hoisted_16 = { class: "block text-xs font-medium text-[#6B7280] dark:text-[#94A3B8] mb-1" }
const _hoisted_17 = { class: "relative" }
const _hoisted_18 = { class: "absolute top-full mt-1 right-0 bg-white dark:bg-[#1e293b] rounded-lg shadow-lg border border-[#E5E7EB] dark:border-[#334155] min-w-[200px] z-10 overflow-hidden" }
const _hoisted_19 = { class: "p-1" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "material-symbols-outlined text-[#6366F1] text-base"
}
const _hoisted_22 = {
  key: 0,
  class: "mt-4 pt-4 border-t border-[#F3F4F6] dark:border-[#334155]"
}
const _hoisted_23 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_24 = { class: "text-xs font-medium text-[#6B7280] dark:text-[#94A3B8]" }
const _hoisted_25 = {
  key: 0,
  class: "flex items-center gap-1 px-2 py-1 bg-[#EDE9FE] text-[#6366F1] rounded-md border border-[#C4B5FD]"
}
const _hoisted_26 = { class: "text-xs font-medium" }
const _hoisted_27 = {
  key: 1,
  class: "flex items-center gap-1 px-2 py-1 bg-[#D1FAE5] text-[#059669] rounded-md border border-[#A7F3D0]"
}
const _hoisted_28 = { class: "text-xs font-medium" }
const _hoisted_29 = {
  key: 2,
  class: "flex items-center gap-1 px-2 py-1 bg-[#E0E7FF] text-[#3730A3] rounded-md border border-[#C7D2FE]"
}
const _hoisted_30 = { class: "text-xs font-medium" }

import { ref, computed, watch } from 'vue';
import { useClickOutside } from "@/utils/useClickOutside";
import { useI18n } from "vue-i18n";
import enTranslations from "@/i18n/locales/en.json";
import heTranslations from "@/i18n/locales/he.json";
import arTranslations from "@/i18n/locales/ar.json";

// Type definition for translation objects
type TranslationObject = {
  [key: string]: string | TranslationObject;
};

// Sort option interface
interface SortOption {
  value: string;
  label: string;
}

// Local filter states

export default /*@__PURE__*/_defineComponent({
  __name: 'ProductsFilter',
  emits: ["filter-change"],
  setup(__props, { emit: __emit }) {

const searchQuery = ref('');
const selectedCategory = ref('');
const selectedSort = ref('');
const minPrice = ref<number | null>(null);
const maxPrice = ref<number | null>(null);

// Emit events to parent
const emit = __emit;

// Function to emit filter changes
const emitFilterChange = () => {
  console.log('Emitting filter change:', {
    search: searchQuery.value,
    category: selectedCategory.value,
    sort: selectedSort.value,
    minPrice: minPrice.value,
    maxPrice: maxPrice.value
  });
  
  emit('filter-change', {
    search: searchQuery.value,
    category: selectedCategory.value,
    sort: selectedSort.value,
    minPrice: minPrice.value,
    maxPrice: maxPrice.value
  });
};

// Computed active filters
const hasActiveFilters = computed(() => {
  return !!(searchQuery.value || selectedCategory.value || minPrice.value || maxPrice.value);
});

// Clear filter functions
const clearCategory = () => {
  selectedCategory.value = '';
  emitFilterChange();
};

const clearPriceRange = () => {
  minPrice.value = null;
  maxPrice.value = null;
  emitFilterChange();
};

const clearSearch = () => {
  searchQuery.value = '';
  emitFilterChange();
};

const clearAllFilters = () => {
  searchQuery.value = '';
  selectedCategory.value = '';
  selectedSort.value = '';
  minPrice.value = null;
  maxPrice.value = null;
  emitFilterChange();
};

// Update filter functions
const updateCategory = (value: string) => {
  selectedCategory.value = value === 'ecommerce.productsGrid.categories.allCategories' ? '' : value;
  emitFilterChange();
};

const updateSort = (value: string) => {
  selectedSort.value = value;
  emitFilterChange();
};

const updatePriceRange = (min: number | null, max: number | null) => {
  minPrice.value = min;
  maxPrice.value = max;
  emitFilterChange();
};

// Watch for search input changes
watch(searchQuery, () => {
  emitFilterChange();
}, { debounce: 300 });

// Filter dropdown states
const categoryFilterOpen = ref(false);
const priceFilterOpen = ref(false);

// Dropdown functionality
const { isActive, toggleActive } = useClickOutside("dropdownToggle");

// Sample data
const categories = ref([
  'ecommerce.productsGrid.categories.allCategories',
  'ecommerce.productsGrid.categories.electronics',
  'ecommerce.productsGrid.categories.clothingFashion',
  'ecommerce.productsGrid.categories.homeGarden',
  'ecommerce.productsGrid.categories.sportsRecreation',
  'ecommerce.productsGrid.categories.foodDrinks',
  'ecommerce.productsGrid.categories.beautyHealth',
  'ecommerce.productsGrid.categories.toysKids'
]);

const sortOptions = ref<SortOption[]>([
  { value: 'default', label: 'ecommerce.productsGrid.sortOptions.default' },
  { value: 'price_low_high', label: 'ecommerce.productsGrid.sortOptions.priceLowHigh' },
  { value: 'price_high_low', label: 'ecommerce.productsGrid.sortOptions.priceHighLow' },
  { value: 'name_asc', label: 'ecommerce.productsGrid.sortOptions.nameAsc' },
  { value: 'name_desc', label: 'ecommerce.productsGrid.sortOptions.nameDesc' },
  { value: 'newest', label: 'ecommerce.productsGrid.sortOptions.newest' },
  { value: 'popular', label: 'ecommerce.productsGrid.sortOptions.popular' },
  { value: 'top_sales', label: 'ecommerce.productsGrid.sortOptions.topSales' }
]);

// Filter actions
const toggleCategoryFilter = () => {
  categoryFilterOpen.value = !categoryFilterOpen.value;
  priceFilterOpen.value = false;
};

const togglePriceFilter = () => {
  priceFilterOpen.value = !priceFilterOpen.value;
  categoryFilterOpen.value = false;
};

const selectCategory = (category: string) => {
  updateCategory(category);
  categoryFilterOpen.value = false;
};

const selectSort = (option: SortOption) => {
  updateSort(option.label);
  toggleActive();
};

const applyPriceFilter = () => {
  updatePriceRange(minPrice.value, maxPrice.value);
  priceFilterOpen.value = false;
};

// Enhanced clear all filters
const clearAllFiltersEnhanced = () => {
  clearAllFilters();
  categoryFilterOpen.value = false;
  priceFilterOpen.value = false;
};

// i18n setup
const { locale } = useI18n();

// Translation files
const translationFiles = {
  en: enTranslations,
  he: heTranslations,
  ar: arTranslations
};

// Direct translation function that bypasses vue-i18n
const directT = (key: string): string => {
  const parts = key.split('.');
  let result: TranslationObject = translationFiles[locale.value as keyof typeof translationFiles];
  
  for (const part of parts) {
    if (!result || !(part in result)) {
      console.warn(`Missing translation key: ${key} in ${locale.value} locale`);
      // Fallback to English if translation not found
      let enResult: TranslationObject = translationFiles.en;
      for (const fallbackPart of parts) {
        if (!enResult || !(fallbackPart in enResult)) return key;
        enResult = enResult[fallbackPart as keyof typeof enResult] as TranslationObject;
      }
      return typeof enResult === 'string' ? enResult : key;
    }
    result = result[part as keyof typeof result] as TranslationObject;
  }
  return typeof result === 'string' ? result : key;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" }, [
            _createElementVNode("i", { class: "material-symbols-outlined text-[#9CA3AF] group-focus-within:text-[#6B7280] transition-colors duration-200 text-lg" }, "search")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (searchQuery.value = $event.target.value)),
            placeholder: directT('ecommerce.productsGrid.searchHere'),
            class: "w-full h-10 pr-10 pl-3 rounded-lg bg-[#F9FAFB] dark:bg-[#0f172a] border border-[#E5E7EB] dark:border-[#334155] text-[#1a1a1a] dark:text-white placeholder-[#9CA3AF] dark:placeholder-[#64748B] focus:outline-none focus:border-[#6366F1] focus:ring-2 focus:ring-[#6366F1]/10 transition-all duration-200 text-sm"
          }, null, 40, _hoisted_5), [
            [_vModelText, searchQuery.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            onClick: toggleCategoryFilter,
            class: "inline-flex items-center px-3 py-2 rounded-lg bg-[#F9FAFB] dark:bg-[#0f172a] border border-[#E5E7EB] dark:border-[#334155] text-[#6B7280] dark:text-[#94A3B8] font-medium hover:bg-[#F3F4F6] dark:hover:bg-[#1e293b] hover:border-[#D1D5DB] dark:hover:border-[#475569] transition-all duration-200 text-sm"
          }, [
            _cache[6] || (_cache[6] = _createElementVNode("i", { class: "material-symbols-outlined mr-1.5 text-base" }, "category", -1)),
            _createTextVNode(" " + _toDisplayString(directT('ecommerce.productsGrid.category')) + " ", 1),
            _createElementVNode("i", {
              class: _normalizeClass(["material-symbols-outlined ml-1.5 transition-transform duration-200 text-base", categoryFilterOpen.value ? 'rotate-180' : ''])
            }, "expand_more", 2)
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: category,
                  onClick: ($event: any) => (selectCategory(category)),
                  class: "w-full text-right px-3 py-2 rounded-md text-[#374151] dark:text-[#E2E8F0] hover:bg-[#F3F4F6] dark:hover:bg-[#334155] transition-all duration-150 font-medium text-sm"
                }, _toDisplayString(directT(category)), 9, _hoisted_10))
              }), 128))
            ])
          ], 512), [
            [_vShow, categoryFilterOpen.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            onClick: togglePriceFilter,
            class: "inline-flex items-center px-3 py-2 rounded-lg bg-[#F9FAFB] dark:bg-[#0f172a] border border-[#E5E7EB] dark:border-[#334155] text-[#6B7280] dark:text-[#94A3B8] font-medium hover:bg-[#F3F4F6] dark:hover:bg-[#1e293b] hover:border-[#D1D5DB] dark:hover:border-[#475569] transition-all duration-200 text-sm"
          }, [
            _cache[7] || (_cache[7] = _createElementVNode("i", { class: "material-symbols-outlined mr-1.5 text-base" }, "payments", -1)),
            _createTextVNode(" " + _toDisplayString(directT('ecommerce.productsGrid.price')) + " ", 1),
            _createElementVNode("i", {
              class: _normalizeClass(["material-symbols-outlined ml-1.5 transition-transform duration-200 text-base", priceFilterOpen.value ? 'rotate-180' : ''])
            }, "expand_more", 2)
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_15, _toDisplayString(directT('ecommerce.productsGrid.min')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((minPrice).value = $event)),
                    placeholder: "0",
                    class: "w-full h-8 rounded-md border border-[#E5E7EB] dark:border-[#334155] bg-[#F9FAFB] dark:bg-[#0f172a] px-2 text-[#374151] dark:text-[#E2E8F0] text-sm outline-none focus:border-[#6366F1] focus:ring-1 focus:ring-[#6366F1]"
                  }, null, 512), [
                    [_vModelText, minPrice.value]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(directT('ecommerce.productsGrid.max')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((maxPrice).value = $event)),
                    placeholder: "∞",
                    class: "w-full h-8 rounded-md border border-[#E5E7EB] dark:border-[#334155] bg-[#F9FAFB] dark:bg-[#0f172a] px-2 text-[#374151] dark:text-[#E2E8F0] text-sm outline-none focus:border-[#6366F1] focus:ring-1 focus:ring-[#6366F1]"
                  }, null, 512), [
                    [_vModelText, maxPrice.value]
                  ])
                ])
              ]),
              _createElementVNode("button", {
                onClick: applyPriceFilter,
                class: "w-full mt-3 px-3 py-2 bg-[#6366F1] text-white rounded-md font-medium hover:bg-[#5048E5] transition-all duration-200 text-sm"
              }, _toDisplayString(directT('ecommerce.productsGrid.apply')), 1)
            ])
          ], 512), [
            [_vShow, priceFilterOpen.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(toggleActive) && _unref(toggleActive)(...args))),
            class: _normalizeClass(["inline-flex items-center px-3 py-2 rounded-lg bg-[#F9FAFB] dark:bg-[#0f172a] border border-[#E5E7EB] dark:border-[#334155] text-[#6B7280] dark:text-[#94A3B8] font-medium hover:bg-[#F3F4F6] dark:hover:bg-[#1e293b] hover:border-[#D1D5DB] dark:hover:border-[#475569] transition-all duration-200 text-sm", { 'bg-[#F3F4F6] dark:bg-[#1e293b] border-[#D1D5DB] dark:border-[#475569]': _unref(isActive) }])
          }, [
            _cache[8] || (_cache[8] = _createElementVNode("i", { class: "material-symbols-outlined mr-1.5 text-base" }, "sort", -1)),
            _createTextVNode(" " + _toDisplayString(selectedSort.value || directT('ecommerce.productsGrid.sort')) + " ", 1),
            _createElementVNode("i", {
              class: _normalizeClass(["material-symbols-outlined ml-1.5 transition-transform duration-200 text-base", _unref(isActive) ? 'rotate-180' : ''])
            }, "expand_more", 2)
          ], 2),
          _withDirectives(_createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortOptions.value, (option) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: option.value,
                  onClick: ($event: any) => (selectSort(option)),
                  class: _normalizeClass(["w-full text-right px-3 py-2 rounded-md text-[#374151] dark:text-[#E2E8F0] hover:bg-[#F3F4F6] dark:hover:bg-[#334155] transition-all duration-150 font-medium text-sm flex items-center justify-between", { 'bg-[#F3F4F6] dark:bg-[#334155] text-[#6366F1]': selectedSort.value === option.label }])
                }, [
                  _createElementVNode("span", null, _toDisplayString(directT(option.label)), 1),
                  (selectedSort.value === option.label)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_21, "check"))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_20))
              }), 128))
            ])
          ], 512), [
            [_vShow, _unref(isActive)]
          ])
        ]),
        (hasActiveFilters.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: clearAllFiltersEnhanced,
              class: "inline-flex items-center px-3 py-2 rounded-lg border border-[#FCA5A5] bg-[#FEF2F2] text-[#DC2626] font-medium hover:bg-[#FEE2E2] transition-all duration-200 text-sm"
            }, [
              _cache[9] || (_cache[9] = _createElementVNode("i", { class: "material-symbols-outlined mr-1.5 text-base" }, "clear_all", -1)),
              _createTextVNode(" " + _toDisplayString(directT('ecommerce.productsGrid.clear')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (hasActiveFilters.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(directT('ecommerce.productsGrid.activeFilters')), 1),
            (selectedCategory.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, _toDisplayString(directT(selectedCategory.value)), 1),
                  _createElementVNode("button", {
                    onClick: clearCategory,
                    class: "hover:bg-[#DDD6FE] rounded-full p-0.5 transition-colors duration-150"
                  }, _cache[10] || (_cache[10] = [
                    _createElementVNode("i", { class: "material-symbols-outlined text-xs" }, "close", -1)
                  ]))
                ]))
              : _createCommentVNode("", true),
            (minPrice.value || maxPrice.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, "₪" + _toDisplayString(minPrice.value || 0) + " - ₪" + _toDisplayString(maxPrice.value || '∞'), 1),
                  _createElementVNode("button", {
                    onClick: clearPriceRange,
                    class: "hover:bg-[#A7F3D0] rounded-full p-0.5 transition-colors duration-150"
                  }, _cache[11] || (_cache[11] = [
                    _createElementVNode("i", { class: "material-symbols-outlined text-xs" }, "close", -1)
                  ]))
                ]))
              : _createCommentVNode("", true),
            (searchQuery.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("span", _hoisted_30, "\"" + _toDisplayString(searchQuery.value) + "\"", 1),
                  _createElementVNode("button", {
                    onClick: clearSearch,
                    class: "hover:bg-[#C7D2FE] rounded-full p-0.5 transition-colors duration-150"
                  }, _cache[12] || (_cache[12] = [
                    _createElementVNode("i", { class: "material-symbols-outlined text-xs" }, "close", -1)
                  ]))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})